<template>
  <div class="kpis-overview-page">
    <Report />
  </div>
</template>

<script>
import Report from '@/components/Metrics/Report.vue'
export default {
  components: {
    Report
  },
  data(){
    return{
      brandid: this.$route.params.Id
    }
  },

}
</script>